module.exports = __webpack_public_path__ + "static/media/model-patrol-88-swb.596fa70f.jpg";